export const FAQ = [
  {
    q: { id: "Apakah konsultasi saya bersifat rahasia?", en: "Is my consultation confidential?" },
    a: {
      id: "Ya. Seluruh sesi konsultasi bersifat rahasia dan mengikuti etika profesi psikologi. Informasi Anda tidak dibagikan tanpa persetujuan, kecuali dalam kondisi yang diwajibkan secara hukum atau menyangkut keselamatan.",
      en: "Yes. All consultations are confidential and follow professional psychology ethics. Your information is not shared without consent, except where legally required or where safety is at risk.",
    },
  },
  {
    q: { id: "Apakah saya perlu rujukan untuk bertemu psikolog?", en: "Do I need a referral to see a psychologist?" },
    a: {
      id: "Tidak. Anda dapat langsung membuat janji konsultasi dengan Bali Empower tanpa rujukan dari dokter atau pihak lain.",
      en: "No. You can book a consultation with Bali Empower directly, without a referral from a doctor or any other party.",
    },
  },
  {
    q: { id: "Di mana lokasi Bali Empower?", en: "Where is Bali Empower located?" },
    a: {
      id: "Bali Empower berlokasi di Apotik Indobat, Jl. Tukad Yeh Aya No. 100, Renon, Denpasar Selatan, Bali 80234, Indonesia.",
      en: "Bali Empower is located at Apotik Indobat, Jl. Tukad Yeh Aya No. 100, Renon, Denpasar Selatan, Bali 80234, Indonesia.",
    },
  },
  {
    q: { id: "Bagaimana cara membuat janji konsultasi?", en: "How do I book a consultation?" },
    a: {
      id: "Anda dapat membuat janji melalui formulir booking di website ini, atau menghubungi kami langsung melalui WhatsApp di 087777430348.",
      en: "You can book through the booking form on this website, or contact us directly via WhatsApp at 087777430348.",
    },
  },
  {
    q: { id: "Berapa biaya konsultasi?", en: "How much does a consultation cost?" },
    a: {
      id: "Biaya konseling mulai dari Rp 250.000 per sesi 60 menit. Sesi bersama pasangan mulai dari Rp 500.000 (90 menit), dan tes/asesmen psikologi mulai dari Rp 400.000 tergantung jenis tes. Rincian lengkap dapat ditanyakan melalui WhatsApp di 087777430348.",
      en: "Counseling fees start from Rp 250,000 per 60-minute session. Joint couple sessions start from Rp 500,000 (90 minutes), and psychological tests/assessments start from Rp 400,000 depending on the test. Full details are available via WhatsApp at 087777430348.",
    },
  },
  {
    q: { id: "Apakah tersedia layanan dalam bahasa Inggris?", en: "Are services available in English?" },
    a: {
      id: "Informasi ketersediaan bahasa akan dikonfirmasi oleh tim kami. Silakan hubungi WhatsApp untuk memastikan. [Akan dilengkapi oleh tim Bali Empower]",
      en: "Language availability will be confirmed by our team. Please contact us via WhatsApp to confirm. [To be confirmed by the Bali Empower team]",
    },
  },
  {
    q: { id: "Apakah konsultasi online tersedia?", en: "Is online consultation available?" },
    a: {
      id: "Ya. Bali Empower menyediakan konseling online (jarak jauh) maupun offline (tatap muka di klinik Renon). Sampaikan metode yang Anda inginkan saat booking melalui website atau WhatsApp di 087777430348.",
      en: "Yes. Bali Empower offers both online (remote) and offline (in-person at the Renon clinic) counseling. Let us know your preferred method when booking via the website or WhatsApp at 087777430348.",
    },
  },
  {
    q: { id: "Jam berapa klinik buka?", en: "What are the opening hours?" },
    a: {
      id: "Jam praktik: Senin–Jumat pukul 10.00–22.00, Sabtu & Minggu pukul 12.00–22.00. Jadwal sesi bersifat tentatif dan disesuaikan dengan antrian — konfirmasi melalui WhatsApp di 087777430348.",
      en: "Practice hours: Monday–Friday 10:00–22:00, Saturday & Sunday 12:00–22:00. Session schedules are tentative and subject to the queue — confirm via WhatsApp at 087777430348.",
    },
  },
];
